import React, { Component } from 'react';
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';

import { savePatientSkillsAcquisitionCollectedData,getPatientSkillAcqPreviousTrialistNewFlow } from './actions/targetsAction';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../../img/small-loader.gif';
import { renderAutoCompleteSingleSelect } from '../../../../../../../../components/reduxFields';
import { delay } from 'lodash';

class TaskAnalysisModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true,
            filteredSteps: this.props.filteredSteps !== null ? this.props.filteredSteps : [],
            patientId: this.props.patientId ? this.props.patientId : null,
            uuid: this.props.uuid,
            postData: [],
            promptCodeListData: this.props.promptCodeListData && this.props.promptCodeListData.data ? this.props.promptCodeListData.data.filter((obj) => obj.maintenance === true) : [],
            patientSkillsAcqDailyTrails: [],
        }
        this.handleNewRequest = this.handleNewRequest.bind(this);
    }

    componentWillMount = () => {
    }

    componentWillReceiveProps(nextProps) {
        let self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                self.handleClose();
            }
        };

        if (nextProps.patientSkillsAcqDailyTrails && this.props.patientSkillsAcqDailyTrails !== nextProps.patientSkillsAcqDailyTrails) {
            let data = nextProps.patientSkillsAcqDailyTrails && nextProps.patientSkillsAcqDailyTrails.filter((obj) => obj.skillsAcquisitionTargetId === this.props.targetObj.skillsAcquisitionTargetId);
            console.log("data",data)
            this.setState({
              patientSkillsAcqDailyTrails: data
            });
          }
        if (nextProps.savedPatientSkillsAcquisitionCollectedData && this.props.savedPatientSkillsAcquisitionCollectedData !== nextProps.savedPatientSkillsAcquisitionCollectedData) {
            this.loadData();
        }
    }

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    componentDidMount(){
        this.loadData();
    }

    loadData(){
        this.props.getPatientSkillAcqPreviousTrialistNewFlow(this.state.patientId, this.state.uuid, this.props.targetObj.skillsAcquisitionTargetId);
    }

    handleNewRequest(input, selectedRecord, obj) { 
        let postData = this.state.postData;
        input.onChange(selectedRecord.value);
        let prompCodeListData = this.state.promptCodeListData;
        let filteredPromtCodeData = prompCodeListData.find(data => {
            return data.id === selectedRecord.value
        })

        let authData = {
                    "id": 0,
                    "collectedDataId": 0,
                    "taskAnalysisId": obj.taskAnalysisId,
                    "patientPromptCodeId": filteredPromtCodeData.promptCodeId,
                    "score": filteredPromtCodeData.scoreAsIndependent === true ? 1 : 0,
                    "statusId": this.props.statusId
        }
        postData.push(authData)
        this.setState({
            postData: postData
        });
    }

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    onSubmitHandler = (formProps) => {
        let authData = {
            "id": 0,
            "skillsAcquisitionProgramId": this.props.targetObj.skillsAcquisitionProgramId,
            "skillsAcquisitionTargetId": this.props.targetObj.skillsAcquisitionTargetId,
            "patientId": this.props.patientId,
            "sessionId": this.props.uuid,
            "sessionDate": this.props.creadteDate,
            "patientPromptCodeId": null,
            "score": null,
            "patientCollectedDataTaskAnalysisModel": this.state.postData,
            "statusId": 0
        }
        this.setState({
            postData: []
        },()=>this.props.savePatientSkillsAcquisitionCollectedData(authData,'TA'));
        delay(()=>this.props.loadData(),200)
    }


    render() {
        const { handleSubmit } = this.props;
        const {patientSkillsAcqDailyTrails} = this.state;
        let submitButton = this.props.loading ?
        <SubmitButtonModalDisabled label="Loading" /> :
        (this.props.addPermissionSkillAquisition && <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />);
        const actions = [
            <CancelButton className="mr-15" onTouchTap={this.handleClose} btnlabel="Cancel" />,
            submitButton,
        ];

        return (
            <Dialog
                className="custom_modal"
                title={this.props.targetObj.targetName}
                modal={false}
                open={this.state.open}
                actions={actions}
                autoScrollBodyContent={true}
            >
                {this.renderLoading()}
                <div className="row mt-20">
                    <div className="col-sm-12">
                        <form className="readmin-form custom_form">
                            <div className="row mt-10">
                                <div className='col-sm-12'>
                                    <span><b>Program Name :</b>&nbsp;{this.props.targetObj.programName}</span>
                                </div>
                            </div>
                            <div className="row mt-10">
                                <div className='col-sm-12'>
                                    <span><b>Target Name :</b>&nbsp;{this.props.targetObj.targetName}</span>
                                </div>
                            </div>
                            <div className="row mt-10">
                                <div className='col-sm-12'>
                                    <span><b>SD :</b>&nbsp;{this.props.targetObj.sd}</span>
                                </div>
                            </div>
                            {/* {this.props.agencyName.toUpperCase() !== VIP &&  */}
                            <div className="row mt-10">
                                <div className='col-sm-12'>
                                    {/* <span><b>Instructions :</b></span>                                     */}
                                    {/* <span style={{ display: 'block', wordWrap: 'break-word'}}>{this.props.targetObj.targetInstructions || this.props.targetObj.programInstructions}</span> */}
                                    <span><b>Instructions :</b> {this.props.targetObj.targetInstructions || this.props.targetObj.programInstructions}</span> 
                                </div>
                            </div>
                            <div className="row mt-10">
                                <div className='col-sm-12'>
                                    <span><b>Trials Done :</b> {patientSkillsAcqDailyTrails[0] && patientSkillsAcqDailyTrails[0].todayCompletedTrails} out of {patientSkillsAcqDailyTrails[0] && patientSkillsAcqDailyTrails[0].desiredDailyTrials}</span>                                       
                                </div>
                            </div>  
                            {/* } */}
                            {/* <div className="row mt-10">
                                <div className='col-sm-12'>
                                    <span><b>Prompt Delay :</b>&nbsp;0</span>
                                </div>
                            </div> */}
                            <div className="row mt-10" style={{ marginLeft: '0px' }}>
                                <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>                                {
                                    this.state.filteredSteps.map((obj, index) => {
                                        return (
                                            <div className="col-sm-12 mt-10" key={index}>
                                                <div className='row'>
                                                    <div className="col-sm-7 mt-10">
                                                        {obj.taskName}
                                                    </div>
                                                    <div className="col-sm-5 mt-10">
                                                        <Field
                                                            name={`answerId${index}`}
                                                            label="Select Prompt Level"
                                                            handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue, obj)}
                                                            options={this.state.promptCodeListData}
                                                            component={renderAutoCompleteSingleSelect} />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                </form>
                            </div>
                        </form>
                    </div>
                </div>
            </Dialog>
        )
    }
}

TaskAnalysisModal = reduxForm({
    form: 'TaskAnalysisModalForm',
    // validate,
    enableReinitialize: true,
})(TaskAnalysisModal);

function mapStateToProps(state, ownProps) {
    return {
        loading: state.patientSkillAcqActiveTarget.loadingTaskAnalysis || state.patientSkillAcqActiveTarget.loading,
        agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
        patientSkillAcqActiveTargetList: state.patientSkillAcqActiveTarget.patientSkillAcqPreviousTrialList !== null && state.patientSkillAcqActiveTarget.patientSkillAcqPreviousTrialList.data.PatientSkillsAcqPreviousTrail,
        patientSkillsAcqDailyTrails: state.patientSkillAcqActiveTarget.patientSkillAcqPreviousTrialList !== null && state.patientSkillAcqActiveTarget.patientSkillAcqPreviousTrialList.data.PatientSkillsAcqDailyTrails,
        savedPatientSkillsAcquisitionCollectedData:state.patientSkillAcqActiveTarget.saved_PatientSkillsAcquisitionCollectedData,
    }
}

export default connect(mapStateToProps, { savePatientSkillsAcquisitionCollectedData, getPatientSkillAcqPreviousTrialistNewFlow })(TaskAnalysisModal);


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/Maintenance/components/targets/TaskAnalysisModal.js